import { AfterContentInit, Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { AbstractBaseAddUpdateComponent } from 'src/app/core/component/abstract-base-add-update-component';
import { IBaseService } from 'src/app/core/service/ibase-service';
import { ModuleParamGlobConfigService } from 'src/app/core/service/moduleFieldConfig/module-param-glob-config.service';
import { CommonSelectListService } from 'src/app/shared/service/common-select-list.service';
import { PartyTypeModal } from '../../party-type/modal/party-type-modal';
import { PartyTypeConstant } from '../../party/modal/party-type-constant';
import { CategoryTypeModel } from '../model/category-type-model';
import { CategoryTypeModuleParamModel } from '../model/category-type-module-param-model';
import { CategoryTypeConstant } from '../model/CategoryTypeConst';
import { CategoryTypeConstantModal } from '../model/CategoryTypeConstModel';
import { CategoryTypeService } from '../service/category-type.service';

@Component({
  selector: 'app-category-type-add-update',
  templateUrl: './category-type-add-update.component.html',
  styleUrls: ['./category-type-add-update.component.css'],
})
export class CategoryTypeAddUpdateComponent
  extends AbstractBaseAddUpdateComponent<CategoryTypeModel>
  implements OnInit, AfterContentInit {
  private readonly MODULE_PARAM_CONFIG_KEY: string = 'categorytype';

  public moduleParams: CategoryTypeModuleParamModel;
  public formGroup: FormGroup;
  public data: CategoryTypeModel;
  public partyTypeList: Array<PartyTypeModal>;
  categortTypeList = CategoryTypeConstant;
  public selectedcategortType: CategoryTypeConstantModal;
  public selectedPartyType: PartyTypeModal;

  constructor(
    public service: CategoryTypeService,
    public router: Router,
    public commonService: CommonSelectListService,
    public toastrService: ToastrService,
    private activeRoute: ActivatedRoute,
    private formBuilder: FormBuilder,
    private moduleParamConfigGlob: ModuleParamGlobConfigService
  ) {
    super(toastrService, router);
  }

  ngOnInit() {
    this.init();
  }

  onCancel() {
    this.router.navigate(['/module/party/partyList']);
  }

  getService(): IBaseService<CategoryTypeModel> {
    return this.service;
  }

  getPartyTypeList() {
    this.commonService.getPartyTypeList().subscribe((res) => {
      this.partyTypeList = new Array<PartyTypeModal>();
      this.partyTypeList = res.dataList;
    });
  }

  setData(data: CategoryTypeModel) {
    this.data = data;
    this.getPartyTypeList();
    if (this.isUpdateComponent) {
      this.selectedcategortType = this.categortTypeList.find((ls) => ls.name === this.data.key);
      this.selectedPartyType = this.data.partyType;
    }
  }

  getData(): CategoryTypeModel {
    return this.data;
  }

  public getModuleHomeUrl(): string {
    return '/module/party/partyList';
  }

  public getActiveRoute(): ActivatedRoute {
    return this.activeRoute;
  }

  public getNewModal(): CategoryTypeModel {
    return new CategoryTypeModel();
  }

  public getFormGroup(): FormGroup {
    return this.formGroup;
  }

  setValidation() {
    this.formGroup = this.formBuilder.group({
      name: ['', Validators.required],
      description: [
        '',
        this.moduleParamConfigGlob.isRequired(this.MODULE_PARAM_CONFIG_KEY, 'description') ? Validators.required : '',
      ],
      partyType: ['', Validators.required],
      categoryType: ['', Validators.required],
    });
  }

  public getId(): number {
    return this.data.id;
  }

  get f() {
    return this.formGroup.controls;
  }

  onSubmit() {
    this.submitted = true;
    if (this.selectedPartyType) {
      let tempPartyType = {
        id: this.selectedPartyType.id,
      };
      this.data.partyType = tempPartyType;
      this.data.key = this.selectedcategortType.name;
      console.log('innn =>', this.data);
    }
    if (this.formGroup.invalid) {
      this.toastrService.warning('Please Fill All The Mandatory Details !!', 'Error');
      return;
    }
    super.onSubmit();
  }

  ngAfterContentInit() {
    this.moduleParams = new CategoryTypeModuleParamModel(this.moduleParamConfigGlob);
  }
}
